export const colors = {
  primary: "#FF4726",
  secondary: "#F6DD99",
  tertiary: "#ffffff",
  black: "#000000",
  white: "#ffffff",

  imageOverlay: "rgba(246, 221, 153, 0.3)"
}

/**
 * In px
 */
export const breakpoints = {
  mobile: 600
}